import {invert} from 'lodash';

import {contactsManagerAccountsUrl} from '../../../../../helpers/contactsManagerHelpers';
import {batch} from '../../../../../helpers/reduxHelpers';
import {AppAction} from '../../../../appActions';
import {ThunkAction} from '../../../../appThunk';
import {navigateToLinkAction} from '../../../../stateless/navigationActions';
import {ContactsManagerPanelId} from '../../../panelStateBase';
import {getContactsManagerPanel} from '../contactsManagerPanelSelectors';
import {ContactsManagerParametersTypesEnum} from '../parameters/contactsManagerParameters';
import {sidePanelIsAccountDetails} from './contactsManagerSidePanelState';

/*
 * Type enum.
 */

export enum ContactsManagerAccountDetailsActionsEnum {
  CLOSE_PANEL = '@@panels/contacts-manager/accounts/account-details/CLOSE_SIDEPANEL',
}

/*
 * Types.
 */

interface ClosePanelAction {
  type: ContactsManagerAccountDetailsActionsEnum.CLOSE_PANEL;
  payload: {
    panelId: ContactsManagerPanelId;
  };
}

/*
 * Action creators.
 */

function closePanel(panelId: ContactsManagerPanelId): ClosePanelAction {
  return {
    type: ContactsManagerAccountDetailsActionsEnum.CLOSE_PANEL,
    payload: {
      panelId,
    },
  };
}

/*
 * Union type.
 */

export type ContactsManagerAccountDetailsAction = ClosePanelAction;

/*
 * Actions.
 */

export function contactsManagerAccountDetailsClosePanelAction(
  shouldNotRedirect: boolean = false,
): ThunkAction {
  return (dispatch, getState) => {
    const contactsManagerPanel = getContactsManagerPanel(getState());
    if (
      !contactsManagerPanel?.sidePanelState ||
      !sidePanelIsAccountDetails(contactsManagerPanel.sidePanelState)
    ) {
      return;
    }

    const {parameters} = contactsManagerPanel;
    batch(() => {
      dispatch(closePanel(contactsManagerPanel.id));

      if (parameters.type === ContactsManagerParametersTypesEnum.ACCOUNTS && !shouldNotRedirect) {
        dispatch(navigateToLinkAction(contactsManagerAccountsUrl));
      }
    });
  };
}

/*
 * Type guards.
 */

const accountDetailsActionsEnumMap = invert(ContactsManagerAccountDetailsActionsEnum);
export function actionIsAccountDetailsAction(
  action: AppAction,
): action is ContactsManagerAccountDetailsAction {
  return action.type in accountDetailsActionsEnumMap;
}
